module.exports = __webpack_public_path__ + "img/back.e3bc3a52.png";